import { ChangeEvent, Dispatch, FC, SetStateAction, useState } from 'react';
import InputMask from 'react-input-mask';
import { useSelector } from 'react-redux';

import useFieldEvents from '@core/hooks/cohesion/useFieldEvents';
import { selectFormCorrelationId } from '@core/reducers/eventingSlice';
import { selectAllInputs } from '@core/reducers/inputsSlice';
import { selectTestResultById, selectAllTestResults } from '@core/reducers/monarchSlice';

type Props = {
  inputName: string;
  setState: Dispatch<SetStateAction<string>>;
};
const InputFieldWithFieldEventing: FC<Props> = ({ inputName, setState }) => {
  const [canFireFieldInputted, setCanFireFieldInputted] = useState(true);
  const formCorrelationId = useSelector(selectFormCorrelationId);
  const formInputs = useSelector(selectAllInputs);

  const noPii = useSelector((state) => selectTestResultById(state, 'noPii'));

  type fieldEventsType = {
    defaultVal: string;
    fieldName: string;
    fieldLabel: string;
  };
  const fieldEventsParams: Record<string, fieldEventsType> = {
    firstName: {
      defaultVal: formInputs.firstName?.value,
      fieldName: 'first-name',
      fieldLabel: 'First Name',
    },
    lastName: {
      defaultVal: formInputs.lastName?.value,
      fieldName: 'last-name',
      fieldLabel: 'Last Name',
    },
    email: {
      defaultVal: formInputs.email?.value,
      fieldName: 'email',
      fieldLabel: 'Email',
    },
    phone: {
      defaultVal: formInputs.phone?.value,
      fieldName: 'phone-number',
      fieldLabel: 'Phone Number',
    },
  };

  const { fieldInputted } = useFieldEvents({
    correlationId: formCorrelationId,
    userInputField: {
      autofilled: true,
      fieldType: 'contact',
      fieldValue: 'SANITIZED',
    },
  });

  const onFormChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setState(value);
    if (canFireFieldInputted) {
      fieldInputted({
        userInputField: {
          fieldName: fieldEventsParams[`${inputName}`].fieldName,
          fieldLabel: fieldEventsParams[`${inputName}`].fieldLabel,
        },
      });
      setCanFireFieldInputted(false);
    }
  };
  const handleFocus = () => {
    setCanFireFieldInputted(true);
  };

  if (inputName === 'phone') {
    return (
      <InputMask
        id="phone"
        mask="(999) 999-9999"
        maskChar=""
        autoComplete="on"
        type="text"
        placeholder="Phone"
        data-testid="pii-form-phone-input"
        defaultValue={fieldEventsParams[`${inputName}`].defaultVal}
        onChange={onFormChange}
        onFocus={handleFocus}
        aria-label="phone"
        data-tf-element-role={`consent-grantor-${inputName}`}
      />
    );
  }

  return (
    <input
      type="text"
      id={inputName}
      data-testid={`pii-form-${inputName}-input`}
      onChange={onFormChange}
      onFocus={handleFocus}
      aria-label={inputName}
      defaultValue={fieldEventsParams[`${inputName}`].defaultVal}
      data-tf-element-role={`consent-grantor-${inputName}`}
      {...(noPii && { placeholder: fieldEventsParams[`${inputName}`].fieldLabel })}
    />
  );
};
export default InputFieldWithFieldEventing;
